// 活动分组
import service from '@/utils/request'

// 列表
export function getActiveGroup (data) {
  return service({
    url: '/service/admin/getActiveGroup',
    method: 'post',
    params: data
  })
}

// 添加
export function addActiveGroup (data) {
  return service({
    url: '/service/admin/addActiveGroup',
    method: 'post',
    params: data
  })
}

// 修改
export function editActiveGroup (data) {
  return service({
    url: '/service/admin/editActiveGroup',
    method: 'post',
    params: data
  })
}

// 删除
export function delActiveGroup (data) {
  return service({
    url: '/service/admin/delActiveGroup',
    method: 'post',
    params: data
  })
}
